document.addEventListener('DOMContentLoaded', function() {
  const baseCurrency = "EUR";
  const rates = { "XOF": 655.957, "USD": 1.08, "GBP": 0.86, "MAD": 10.7, "CAD": 1.46, "default": 1 };
  
  function cleanPrice(text) {
    if (!text) return null;
    text = text.replace(/\s/g, '').replace(/\u202F/g, '').replace(/[^0-9.,]/g, '');
    if (text.includes(',') && text.includes('.')) {
      if (text.indexOf(',') < text.indexOf('.')) text = text.replace(/,/g, '');
      else text = text.replace(/\./g, '').replace(',', '.');
    } else if (text.includes(',')) text = text.replace(/,/g, '.');
    return parseFloat(text);
  }

  function formatPrice(value, currency) {
    if (currency === 'XOF') return Math.round(value).toLocaleString('fr-FR') + ' XOF';
    else return value.toLocaleString('fr-FR', { style: 'currency', currency: currency });
  }

  async function detectCurrency() {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 2000);
      const response = await fetch('https://ipapi.co/currency/', { signal: controller.signal });
      clearTimeout(timeoutId);
      const currency = await response.text();
      return rates[currency.trim()] ? currency.trim() : baseCurrency;
    } catch (error) {
      console.warn('Erreur de détection devise, fallback EUR');
      return baseCurrency;
    }
  }

  async function convertAllPrices() {
    const visitorCurrency = await detectCurrency();
    const conversionRate = rates[visitorCurrency] || rates.default;
    document.querySelectorAll('.money, .price, .product-price').forEach(el => {
      if (el.dataset.converted === "true") return;
      if (!el.dataset.originalPrice) {
        const original = cleanPrice(el.innerText);
        if (!isNaN(original)) el.dataset.originalPrice = original;
      }
      const originalPrice = parseFloat(el.dataset.originalPrice);
      if (!isNaN(originalPrice)) {
        const newPrice = originalPrice * conversionRate;
        el.innerText = formatPrice(newPrice, visitorCurrency);
        el.dataset.converted = "true";
      }
    });
  }

  if ('requestIdleCallback' in window) requestIdleCallback(convertAllPrices);
  else setTimeout(convertAllPrices, 400);
});
